import React from "react";
import Layout from "../layouts/GeneralLayout";
import MoverInfoScreen from "../screens/Info/MoverInfo";

const MoverInfo = () => {
  return (
    <Layout>
      <MoverInfoScreen />
    </Layout>
  );
};

export default MoverInfo;
